console.log('js/language_tracking.js -> v0.1.0');

$(function () {
	var tpLangSiteId = "site" + siteid;
	var langCateg = "language_uprank";

	if (typeof(tpLangUprank) != "undefined" && typeof(tpLangUprankPage) != "undefined") {
		var action = [
			tpLangSiteId,
			selectedLanguage,
			tpLangUprank,
			tpLangUprankPage
		].join("--");
		gae(langCateg, action);
	}
});
